import { PosBookmarkCreatePage } from '@/features/pos-bookmark/pages/PosBookmarkCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pos-bookmark/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pos_bookmark.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PosBookmarkCreatePage,
})
